// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoModal_video__EBspT","videoContent":"VideoModal_videoContent__WJUDJ","close":"VideoModal_close__Wp_g1","videoItem":"VideoModal_videoItem__hxXeB"};